// extracted by mini-css-extract-plugin
module.exports = {"button":"ModalCloseButton_button__DeRYv"};